// extracted by mini-css-extract-plugin
export default {"gif":"LocalStorageBlockedModal_gif__pCEGP","text":"LocalStorageBlockedModal_text__XjftK"};